<template>
  <div class="d-flex align-items-center">
    <div
      v-show="show"
      ref="basePopover"
      class="base-popover"
      :style="position"
    >
      <div
        v-if="show"
        class="base-popover__back"
        @click.stop="close"
      />
      <div class="base-popover__arrow" />
      <div
        v-if="show"
        ref="basePopoverBox"
        class="base-popover__box"
        :class="'base-popover__box--' + boxClass"
        :style="{'min-width': `${minWidth}px`}"
        @mouseleave="close"
      >
        <!-- Close button -->
        <!-- <div
          class="base-popover__button-close"
          @click.stop="close"
        >
          <font-awesome-icon icon="times" />
        </div> -->
        <!-- /Close button -->

        <!-- Header -->
        <div class="base-popover__header">
          <slot name="header">
            <div class="base-popover__header__content">
              {{ title }}
            </div>
          </slot>
        </div>
        <!-- /Header -->

        <!-- Content -->
        <div class="base-popover__content">
          <slot name="content" />
        </div>
        <!-- /Content -->

        <!-- Footer -->
        <div class="base-popover__footer">
          <slot name="footer" />
        </div>
        <!-- /Footer -->
      </div>
    </div>

    <!-- Button -->
    <span
      ref="basePopoverButton"
      class="base-popover__button"
      @click.stop.prevent="toggle"
      @mouseenter="open"
    >
      <slot :data="defaultData">
        Boton aca
      </slot>
    </span>
    <!-- /Button -->
  </div>
</template>
<script>
import { EventBus } from '../../event-bus';

export default {
  name: 'BasePopover',
  props: {
    defaultData: {
      type: Object,
    },
    title: {
      type: String,
      default: '',
    },
    minWidth: {
      type: Number,
      default: 208,
    },
  },
  data() {
    return {
      show: true,
      position: {},
      boxClass: '',
    };
  },
  watch: {
    show(value) {
      if (value === true) {
        this.$emit('open');
        this.setPosition();
      } else {
        this.$emit('close');
      }
    },
  },
  mounted() {
    // Adds the element to the body
    // document.body.insertBefore(this.$refs.basePopover, document.querySelector('#app'))
    document.body.insertBefore(this.$refs.basePopover, document.body.firstChild);
    // document.body.appendChild(this.$refs.basePopover)
    this.show = false;
    EventBus.$on('hidePopover', () => {
      this.show = false;
    });
  },
  beforeDestroy() {
    this.$emit('close');
    this.show = false;
    if (this.$refs.basePopover) {
      this.$refs.basePopover.remove();
    }
  },
  methods: {
    setPosition() {
      this.$nextTick(() => {
        const buttonRect = this.$refs.basePopoverButton.getBoundingClientRect();
        // const basePopoverBox = this.$refs.basePopoverBox.getBoundingClientRect();
        // const bodyRect = document.body.getBoundingClientRect();

        this.position = {
          top: `${buttonRect.bottom}px`,
          left: `${(buttonRect.width / 2) + buttonRect.left - 10}px`,
        };
      });
    },
    toggle() {
      this.show = !this.show;
    },
    open() {
      this.show = true;
    },
    close() {
      this.show = false;
    },
  },

};
</script>
<style lang="scss">
  .base-popover{
    $b: &;
    position: absolute;
    max-width: 500px;
    display: flex;
    flex-direction: column;
    align-items: center;

    &__back{
      // background: rgba(black, 0.2);
      position: fixed;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      z-index: 9998;
    }

    &__box{
      background-color: white;
      border-radius: 3px;
      box-shadow: 0 1px 1px rgba(black, 0.2);
      padding: 0.75rem;
      position: absolute;
      top: 100%;
      border: solid 1px #ccc;
      z-index: 9999;
      max-height: 100vh;
      // overflow-y: hidden;
      transform: translateY(-1px);
      &:before{
        content: " ";
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate(-50%, -100%);
        height: 50px;
        width: 50px;
      }
    }
    &__content{
      max-height: 300px;
      overflow-y: auto;
    }

    &__header{}
    &__header__content{
      border-bottom: solid 1px rgba(black, 0.2);
      padding-bottom: 12px;
      margin-bottom: 18px;
      text-align: center;
    }

    &__button{
      cursor: pointer;
    }

    &__button-close{
      position: absolute;
      right: 0.75rem;
      top: 0.75rem;
      cursor: pointer;

      opacity: 0.3;
      transition: opacity 0.3s;
      border-radius: 3px;
      padding: 0 5px;
      &:hover{
        opacity: 0.8;
        background-color: rgba(black, 0.05);
      }
    }

    &__arrow{
      // position: absolute;
      width: 20px;
      height: 20px;
      // background-color: red;
      // left: -20px;
      // top: 0;
      overflow: hidden;
      // transform: rotate(90deg);
      z-index: 10000;
      pointer-events: none;

      &:after{
        background-color: white;
        content: '';
        width: 20px;
        height: 20px;
        // box-shadow: 1px 1px 1px rgba(black, 0.2);
        transform: rotate(45deg) translateY(10px) translateX(10px);
        display: block;
        border: solid 1px #ccc;
      }
    }

    &__box--left{
      #{$b}__arrow{
        left: inherit;
        right: -20px;
        top: 10px;
        transform: rotate(180deg);
      }
    }
    &__box--right{}
  }
</style>
